import TitleBar from "../components/TitleBar";

const board = [
  {
    office: "President",
    officers: ["Kevin Roberts"],
  },
  {
    office: "Secretary/Treasurer",
    officers: ["Michael Thorn"],
  },
  {
    office: "Assistant Secretary",
    officers: ["Chris Koop"],
  },
  {
    office: "Directors",
    officers: [
      "Mike Brown",
      "Alan Conkle",
      "Terry Eckert",
      "Walt Hazelton",
      "Charlie Miller",
      "Stephen Wilde",
      "Marge Washburn",
    ],
  },
  {
    office: "Program Manager",
    officers: ["Sherry Wilde"],
  },
  {
    office: "Assistant Manager",
    officers: ["Shannon LaForce"],
  },
];

export default function About() {
  return (
    <>
      <TitleBar />
      <main className="w-full">
        <div className="mx-auto max-w-[85rem] px-8">
          <section className="mt-4">
            <h1 className="my-2 font-serif text-3xl font-bold italic text-(--darkred)">
              About EVTCC
            </h1>
            <p className="my-2">
              The EVT Certification Commission, Inc. is a nonprofit corporation
              dedicated to improving the quality of emergency vehicle service
              and repair throughout the United States and Canada by means of a
              certification program that will provide technicians recognition
              for the education, training, and experience they have in the
              service and repair of emergency vehicles.{" "}
            </p>
          </section>
          <section>
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Board of Directors
            </h2>
            {board.map((position) => (
              <div className="my-2" key={position.office}>
                <h3 className="ml-2 font-serif text-xl font-bold italic">
                  {position.office}
                </h3>
                <div className="ml-4 grid grid-cols-[repeat(auto-fill,minmax(160px,2fr))] gap-4">
                  {position.officers.map((of) => (
                    <div className="w-full" key={of}>
                      {of.split(" ").join("\xa0")}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </section>
        </div>
      </main>
    </>
  );
}
